// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState } from 'vuex';
import loading from '../../../../share/components/vue/ProcessingIcon';
import logWrapper from '../../../../share/logWrapper';
import error from '../../../../common/nodejs/errors';
import constants from '../../../../common/nodejs/constants';
import eventLogUtil from '../../../../share/util/eventLogUtil';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      modelUpdateProcessing: true,
      turnIgOnChecked: false,
      errorCodes: error,
      constants: constants,
      modal_key_inspection_platform_gen_decision: false,
      modal_key_inspection_progress: false,
      modal_key_inspection_ig_on: false,
      modal_key_inspection_ig_on_retry: false,
      modal_key_inspection_err_failed: false,
      modal_key_inspection_completed: false
    };
  },

  props: {
    turnOnIgnition: Function,
    macStatusInfo: Object,
    onSetEndOfProcessingFlag: Function,
    currentDialogId: String,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false, nextDialog: "" }),
    },
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      vehicle: state => state.vehicle,
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * platform_genが19ePFか否かを判定する。
     * @returns {boolean} platform_genが19ePFの場合はtrueを返し、それ以外の場合はfalseを返す。
     */
    isPlatformGen19epf() {
      return this.macStatusInfo.platform_gen === constants.MAC_KEY_PLATFORM_GEN_19EPF;
    },
  },

  watch: {
    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "_");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
            if (value.nextDialog) {
              const nextId = value.nextDialog.replace(/-/g, "_");
              if (util.hasPropertyCheck(this, nextId)) {
                this[nextId] = true;
              }
            }
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    /**
     * 鍵検証のIG-ON指示画面でボタンを押下した際の処理
     * @param {String} action ボタンの種類
     */
    macInspectionEventOnIgnition: function (action) {
      this.turnOnIgnition(action, 'modal-key-inspection-progress');
      this.turnIgOnChecked = false;
      if (action === 'cancel') {
        eventLogUtil.updateMacEventLog(this.netAppId);
        if (this.vehicle.vehicleInfo === null) this.onSetEndOfProcessingFlag();
      }
    },

    /**
     * 鍵検証完了/エラー画面でOKボタンを押下した際の処理
     * @param {String} error_code エラーコード
     */
    onOkButtonClick: function (error_code) {
      const id = this.currentDialogId.replace(/-/g, "_");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
      if (error_code !== error.IG_ON_RETRY_ERROR_CODE) this.determineEndOfProcessingFlag();
      this.turnIgOnChecked = false;
    },

    /**
     * 処理完了フラグを設定する
     */
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
  },

  created() { },

  mounted() { },

};